import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Pipe to take HTML and allow it to be executed

@Pipe({
  name: 'noSanitise'
})
export class SanitiseHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }
  transform(value: unknown): SafeHtml | null {
    if (typeof value !== 'string') return null;  // only allow strings
    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }
}
